const SvgWatchOutlined = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 2.667c-7.333 0-13.333 6-13.333 13.333s6 13.333 13.333 13.333 13.333-6 13.333-13.333S23.333 2.667 16 2.667M21.6 21.6l-6.933-4.267v-8h2v6.933l6 3.6z" />
  </svg>;
export default SvgWatchOutlined;